import { ClipboardList, HeartPulse, ScanLine } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { CardButton } from '@/components/card-button'
import { PageHeader } from '@/components/commons'
import { hasRouteAccess } from '@/constants/permissions'
import { ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/store'

export const DDSHubPage = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const userRole = useAuthStore((state) => state.user?.role)

	const options = [
		{
			id: 'checkIn',
			icon: <ScanLine className="size-5 text-kaefer-grass-green" />,
			route: ROUTES.DDS.CHECK_IN,
			iconBg: 'bg-kaefer-grass-green/10',
			borderColor: 'border-l-kaefer-grass-green',
		},
		{
			id: 'list',
			icon: <ClipboardList className="size-5 text-kaefer-honey-yellow" />,
			route: ROUTES.DDS.INDEX,
			iconBg: 'bg-kaefer-honey-yellow/10',
			borderColor: 'border-l-kaefer-honey-yellow',
		},
		{
			id: 'emotions',
			icon: <HeartPulse className="size-5 text-kaefer-raspberry-pink" />,
			route: ROUTES.DDS.EMOTIONS,
			iconBg: 'bg-kaefer-raspberry-pink/10',
			borderColor: 'border-l-kaefer-raspberry-pink',
		},
	]

	const visibleOptions = userRole
		? options.filter((option) => hasRouteAccess(userRole, option.route))
		: options

	return (
		<div className="px-4 py-6 sm:px-6">
			<PageHeader
				title={t('ddsHub.title')}
				description={t('ddsHub.subtitle')}
				onBack={() => navigate(ROUTES.DASHBOARD.HOME)}
			/>

			<div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2">
				{visibleOptions.map((option) => (
					<CardButton
						key={option.id}
						icon={option.icon}
						iconBg={option.iconBg}
						borderColor={option.borderColor}
						title={t(`ddsHub.options.${option.id}.title`)}
						description={t(`ddsHub.options.${option.id}.description`)}
						onClick={() => navigate(option.route)}
					/>
				))}
			</div>
		</div>
	)
}
